import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon as solidMoon } from "@fortawesome/free-solid-svg-icons";
import { faMoon as emptyMoon } from "@fortawesome/free-regular-svg-icons";

export default function ThemeSetter({ theme, onclick }) {
  return (
    <button value={theme} className="theme-btn" onClick={onclick}>
      <FontAwesomeIcon icon={theme === "light" ? emptyMoon : solidMoon} />
      Dark Mode
    </button>
  );
}
